const formateadorCorto = new Intl.DateTimeFormat('es-CR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
});
const formateadorLargo = new Intl.DateTimeFormat('es-CR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
});
const SOLO_FECHA = /^(\d{4})-(\d{2})-(\d{2})$/;
/**
 * `new Date('YYYY-MM-DD')` la interpreta como medianoche UTC (spec de JS).
 * En una zona horaria negativa como Costa Rica (UTC-6), formatearla luego
 * con la zona local le resta un día (26/08 aparecía como 25/08). Estos
 * strings son fechas de calendario puras (fecha_colado, fecha_prueba…),
 * sin hora ni zona horaria real, así que hay que construirlas con
 * componentes LOCALES para que no se corran al mostrarlas.
 *
 * Un timestamp real (con hora, ej. `creado_en`) sí representa un instante
 * y debe convertirse normalmente de UTC a local — ese caso sigue el
 * camino de siempre.
 */
function aDate(fecha) {
    if (fecha instanceof Date)
        return Number.isNaN(fecha.getTime()) ? null : fecha;
    const soloFecha = SOLO_FECHA.exec(fecha);
    if (soloFecha) {
        const [, y, m, d] = soloFecha;
        return new Date(Number(y), Number(m) - 1, Number(d));
    }
    const d = new Date(fecha);
    return Number.isNaN(d.getTime()) ? null : d;
}
export function formatearFechaCR(fecha, formato = 'corto') {
    const d = aDate(fecha);
    if (!d)
        return '—';
    switch (formato) {
        case 'corto':
            return formateadorCorto.format(d);
        case 'largo':
            return formateadorLargo.format(d);
        case 'iso': {
            const yyyy = d.getFullYear();
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const dd = String(d.getDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd}`;
        }
    }
}
//# sourceMappingURL=formatearFecha.js.map